module.exports = __webpack_public_path__ + "static/media/prpg.4970c1b7.png";